var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "44.98 49.96 159.47 156.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m193.6 71.18c-3.8 3.16-7.38 5.12-12.29 6.56 6.63 11.2 8.26 20.74 7.95 35.43-0.76 26.79-20.32 53.89-48.35 61.92-0.96 7.76-2.88 11.95-5.38 15.57 37.4-5.23 64.24-37.04 68.31-71.4 2.18-17.23-1.57-34.15-10.24-48.08z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m103.6 206.7c19.43-3.75 31.23-21.89 31.51-36.01l-0.08-86.14c0-7.11 5.73-10.93 11.13-10.87h20.81c10.59 0 19.35-3.36 22.77-7.45-7.18-9.46-12.01-16.01-22.16-16.27h-85.98c-9.39-0.17-15.04 5.28-21.92 15.86 6.45 5.57 16.18 7.74 23.44 7.78h31.24v101.9c-29.06-4.13-54.23-29.5-54.35-62.86-0.05-12.92 2.88-22.78 8.24-34.88-6.38-1.94-10.03-4.12-12.33-6.65-8.32 13.63-11.41 27.94-10.88 43.19 1.19 32.65 23.45 64.84 62.49 74.78-0.59 5.94-1.83 10.69-3.93 17.59z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m101.8 112.3c0 7.7-7.07 11.96-12.1 11.25-7.2-1.02-11.67-6.81-11.46-11.53 0.28-7.33 5.99-11.56 11.66-11.74 7.95-0.31 11.98 6.42 11.9 12.02z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m108 142v26.12c-13.63-4.36-25.21-12.91-33.97-27.8 4.72-8.11 11.13-12.12 18.39-11.92 7.73 0.48 15.81 6.99 15.58 13.6z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m170.8 105.9c3.66 6.68-0.59 15.44-9.09 17.42-7.55 0.95-13.77-5.09-14.67-10.22-0.81-7.1 5.43-13.13 11.83-12.8 5.93-0.4 10.19 2.65 11.93 5.6z",
    fill: "#449CF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m140.7 142.6v25.23c11.43-3.5 23.72-10.59 34.08-27.71-4.57-8.11-11.03-12.22-18.04-11.59-8.02 1.22-15.72 6.51-16.04 14.07z",
    fill: "#449CF5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 170.9,
    x2: 170.9,
    y1: 71.18,
    y2: 190.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#449CF5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2848EE",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 120.7,
    x2: 120.7,
    y1: 50,
    y2: 206.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06A7F2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2138F5",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 89.86,
    x2: 89.86,
    y1: 100.3,
    y2: 123.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18A4F4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7DF1",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 91.06,
    x2: 91.06,
    y1: 128.4,
    y2: 168.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1089F5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7DF1",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f05f97ded4bfa39da3858c81ab81cfd0.svg";
export { ForwardRef as ReactComponent };